exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"variables.scss"}]);

// Exports
exports.locals = {
	"colorPrimary": "#4ca94d"
};